import React, { useState ,useEffect,useRef} from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLogoutMutation } from "../slices/postqueries/userqueriesApi";
import { setAllNull } from "../slices/DateAndTimeslice";
import { logout } from "../slices/authslice";
import { toast } from "react-toastify";
import HeaderLogo from '../assets/Graviton.svg';
import { LuLogOut } from "react-icons/lu";
import { TbUserEdit } from "react-icons/tb";

function NewHeader({toggleSidebar,isSidebarOpen}) {
    const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(setAllNull());
      localStorage.removeItem('dashboardFromDate');
      localStorage.removeItem('dashboardToDate');
      localStorage.removeItem('selected_card');
      navigate("/login");
      toast.success("successfully logged out!");
    } catch (err) {
      console.log(err);
    }
  };

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  
  const handleToggle = () => setOpen((prev) => !prev);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
  
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
  
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);
  
  return (
    <header className="flex items-center justify-between px-4 py-2  sm:w-full md:w-full lg:w-full">
  <div className="flex items-center space-x-2">
   
    <button
  onClick={toggleSidebar}
  className="md:hidden text-4xl text-[#204887] mr-2"
>
  {isSidebarOpen ? "✖" : "☰"}
</button>
    <img src={HeaderLogo} alt="Logo" className="h-16 w-auto max-w-[200px] object-contain" />
  </div>
      
      {userInfo && (
  <div className="relative" ref={dropdownRef}>
    <div
      onClick={handleToggle}
      className="flex items-center space-x-2 min-w-[150px] justify-end cursor-pointer"
    >
      <div className="w-[28px] h-[28px] rounded-full bg-blue-100 text-blue-800 flex items-center justify-center text-[20px] font-semibold">
        {userInfo.clientId[0]}
      </div>
      <span className="text-[20px] text-gray-800">{userInfo.clientId}</span>
    </div>

    {open && (
      <div className="absolute right-0 w-48 bg-white rounded-lg shadow-lg z-50">
        <div
          className="px-4 py-2 cursor-pointer flex items-center space-x-2 hover:bg-gray-100 hover:rounded-t-lg"
          onClick={() => {
            setOpen(false);
            navigate('/profile');
          }}
        >
          <TbUserEdit size={18} className="text-gray-700" />
          <span className="text-[#4B5563] text-[14px] hover:text-[#204887]">
            Profile
          </span>
        </div>
        <div
          className="px-4 py-2 cursor-pointer flex items-center space-x-2 hover:bg-gray-100 hover:rounded-b-lg"
          onClick={logoutHandler}
        >
          <LuLogOut size={18} className="text-gray-700" />
          <span className="text-[#4B5563] text-[14px] hover:text-[#204887]">
            Log Out
          </span>
        </div>
      </div>
    )}
  </div>
)}

    </header>
  )
}

export default NewHeader
